'use client';

import { useEffect } from 'react';
import { useCurrentUser } from '@/modules/auth/context/CurrentUserContext';
import { getRollbar } from '@/services/rollbar';

/**
 * Client-side component to initialize Rollbar and dynamically
 * track the authenticated user state.
 */
export default function RollbarUserTracker() {
  const { user } = useCurrentUser();

  // Initialize Rollbar on the client side once when mounted
  useEffect(() => {
    getRollbar();
  }, []);

  // Sync authenticated user context with Rollbar
  useEffect(() => {
    const rollbar = getRollbar();
    if (!rollbar) return;

    if (user) {
      rollbar.configure({
        payload: {
          person: {
            id: String(user.id || ''),
            email: String(user.email || ''),
            username: String(user.name || ''),
          },
        },
      });
    } else {
      // Clear context when user logs out
      rollbar.configure({
        payload: {
          person: undefined,
        },
      });
    }
  }, [user]);

  return null;
}
